import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Journey from '../components/Journey';
import VumaQash from '../components/VumaQash';
import Countries from '../components/Countries';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <div>
      <Hero />
      <Stats />
      <Journey />
      <VumaQash />
      <Countries />
      <Testimonials />
      <CTA />
    </div>
  );
};

export default Home;